import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'loading-history-drawer',
  templateUrl: './loading-history.component.html',
  styleUrls: ['./loading-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingHistoryComponent {}
